import React from 'react';
import moment from 'moment';

const QuestionListItem = ({ item, handleClick }) => {
  return (
    <div
      className="d-flex flex-row border-bottom conversation"
      onClick={() => handleClick(0, item.conversationId)}
      style={{ cursor: 'pointer' }}
    >
      <div className="pl-3 pt-2 pr-2 pb-2 conversation">
        <p className="mb-1 text-small">
          {moment(item.time).format('DD/MM/YYYY h:mm a')}
        </p>
        <div className="pr-4">
          <p className="mb-1 text-medium">{item.text}</p>
        </div>
      </div>
    </div>
  );
};

export default React.memo(QuestionListItem);
